import { useGameStore } from "../../store/gameStore";
import { Button } from "../ui/button";
import { ShieldAlert } from "lucide-react";

// GM-only floating prompt when a player wants to attempt an out-of-range attack. The roll stays
// locked on the player's side until the GM taps Allow — keeps this an explicit GM call, not
// something a player can quietly slip past.
export default function RangeApprovalBar({ isGm, sendWs }) {
  const pending = useGameStore((s) => s.pendingRangeApproval);
  const setPending = useGameStore((s) => s.setPendingRangeApproval);

  if (!isGm || !pending) return null;

  const allow = () => {
    sendWs({ type: "range_approval_grant", data: { request_id: pending.request_id, requester_member_id: pending.requester_member_id } });
    setPending(null);
  };

  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-30 flex items-center gap-3 bg-[#322216]/95 border border-[#D90429]/40 rounded-full px-4 py-2 shadow-xl" data-testid="range-approval-bar">
      <ShieldAlert className="w-4 h-4 text-[#D90429] shrink-0" />
      <span className="text-xs text-[#f1e0c5]/80">{pending.requester_name} wants to attack {pending.target_name} out of range with {pending.attack_label}</span>
      <Button data-testid="range-approval-allow-button" size="sm" onClick={allow} className="rounded-full h-7 text-xs bg-[#D90429] hover:bg-[#b8031f]">Allow</Button>
      <button data-testid="range-approval-dismiss-button" onClick={() => setPending(null)} className="text-[#f1e0c5]/40 hover:text-white text-xs">Dismiss</button>
    </div>
  );
}
